import axios from "@/util/axios";
export default {
    loadProductList() {
        return axios.get(`/api/product/list`);
    },
    loadPipelineList: function (productId, filterParams, currentPage) {
        return axios.post(`/api/product/${productId}/pipelineList`, { 'filterParams': filterParams,  currentPage});
    },
    loadBuildParams: function (pipelineId) {
        return axios.get(`/api/pipeline/${pipelineId}/buildParams`);
    },
    loadPipelineDetail: function (pipelineId) {
        return axios.get(`/api/pipeline/${pipelineId}/get`);
    },
    changeFollowStatus: function (productId, pipelineId) {
        return axios.post(`/api/pipeline/${pipelineId}/followStatus`, { 'productId': productId });
    },
    startBuild: function (pipelineId, buildParams) {
        return axios.post(`/api/pipeline/${pipelineId}/start`, buildParams);
    },
    saveAutoTask: function (pipelineId, autoTaskId, productId) {
        return axios.post(`/api/pipeline/${pipelineId}/saveAutoTask`, { 'productId': productId, 'autoTaskId': autoTaskId });
    }
}